'use client';
import { useState } from 'react';
import { HiPlusCircle, HiStatusOnline, HiXCircle } from 'react-icons/hi';

import useMyTestsState from 'src/hooks/useMyTestsState';

type Props = {
    test: any;
    className?: string;
    withLabel?: boolean;
    asButton?: boolean;
};

export default function MyTestButton({ test, className = '', withLabel = false, asButton = false, ...rest }: Props) {
    const { tests, loaded, addTest, removeTest } = useMyTestsState();
    const [loading, setLoading] = useState(false);

    const isActive = loaded && tests?.some((t) => t && t.slug === test);
    const prefix = `cursor-pointer flex items-center justify-center hover:underline ${asButton ? 'btn' : ''} ${
        className || ''
    }`.trim();
    const cn = isActive
        ? `${prefix} ${asButton ? 'btn-danger' : 'text-danger'}`
        : `${prefix} ${asButton ? 'btn-primary' : 'text-primary'}`;

    const handleClick = () => {
        if (loading) return;

        setLoading(true);
        if (isActive) {
            removeTest(test).finally(() => setLoading(false));
        } else {
            addTest(test).finally(() => setLoading(false));
        }
    };

    return (
        <div
            {...rest}
            className={cn}
            onClick={handleClick}
            role="button"
            aria-label={isActive ? 'Șterge analiza' : 'Adaugă analiza'}>
            {!asButton && (
                <>
                    {loading ? (
                        <HiStatusOnline className="text-primary/50 animate-spin text-3xl" />
                    ) : isActive ? (
                        <HiXCircle className="text-3xl" />
                    ) : (
                        <HiPlusCircle className="text-3xl" />
                    )}
                </>
            )}
            {withLabel && <span className="ml-2">{isActive ? 'Șterge analiza' : 'Adaugă analiza'}</span>}
        </div>
    );
}
